import { OptionsType } from 'src/types';
import axios from '../axios';
import routes from '../routes';

const options = {
  loadOptions: (): Promise<Partial<OptionsType>> => axios.get(routes.OPTIONS),
};

export default options;
